// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_uj-0";